/**
 * Regional Amazon storefront and Seller Central URLs from SP-API marketplace codes.
 * Never assume amazon.com when a marketplace code is known (IT → amazon.it, etc.).
 */

export var AMAZON_MARKETPLACE_HOSTS = {
  DE: 'www.amazon.de',
  CN: 'www.amazon.cn',
  UK: 'www.amazon.co.uk',
  JP: 'www.amazon.co.jp',
  FR: 'www.amazon.fr',
  ES: 'www.amazon.es',
  IT: 'www.amazon.it',
  US: 'www.amazon.com',
  MX: 'www.amazon.com.mx',
  IN: 'www.amazon.in',
  CA: 'www.amazon.ca',
  BR: 'www.amazon.com.br',
  NL: 'www.amazon.nl',
  TR: 'www.amazon.com.tr',
  AE: 'www.amazon.ae',
  SA: 'www.amazon.sa',
  AU: 'www.amazon.com.au',
  SG: 'www.amazon.sg',
  PL: 'www.amazon.pl',
  SE: 'www.amazon.se',
  BE: 'www.amazon.com.be',
  AT: 'www.amazon.de',
  ZA: 'www.amazon.co.za',
  EG: 'www.amazon.eg',
  IE: 'www.amazon.ie'
}

/** Seller Central hostname per marketplace code. */
export var SELLER_CENTRAL_HOSTS = {
  US: 'sellercentral.amazon.com',
  CA: 'sellercentral.amazon.ca',
  MX: 'sellercentral.amazon.com.mx',
  BR: 'sellercentral.amazon.com.br',
  UK: 'sellercentral.amazon.co.uk',
  DE: 'sellercentral.amazon.de',
  FR: 'sellercentral.amazon.fr',
  IT: 'sellercentral.amazon.it',
  ES: 'sellercentral.amazon.es',
  NL: 'sellercentral.amazon.nl',
  BE: 'sellercentral.amazon.com.be',
  SE: 'sellercentral.amazon.se',
  PL: 'sellercentral.amazon.pl',
  TR: 'sellercentral.amazon.com.tr',
  IN: 'sellercentral.amazon.in',
  AE: 'sellercentral.amazon.ae',
  SA: 'sellercentral.amazon.sa',
  EG: 'sellercentral.amazon.eg',
  AU: 'sellercentral.amazon.com.au',
  SG: 'sellercentral.amazon.sg',
  JP: 'sellercentral-japan.amazon.com',
  ZA: 'sellercentral.amazon.co.za',
  AT: 'sellercentral.amazon.de',
  IE: 'sellercentral.amazon.co.uk',
  CN: 'sellercentral.amazon.cn'
}

export function normalizeMarketplaceCode (marketplace) {
  if (marketplace == null || marketplace === '') return ''
  var mp = String(marketplace).trim().toUpperCase()
  if (mp === 'GB') return 'UK'
  return mp
}

export function amazonHostForMarketplace (marketplace, fallbackUrl) {
  var mp = normalizeMarketplaceCode(marketplace)
  if (mp && AMAZON_MARKETPLACE_HOSTS[mp]) return AMAZON_MARKETPLACE_HOSTS[mp]
  if (fallbackUrl && typeof fallbackUrl === 'string') {
    try {
      var u = new URL(fallbackUrl)
      if (/amazon\./i.test(u.hostname)) return u.hostname
    } catch (e) { /* ignore */ }
  }
  return AMAZON_MARKETPLACE_HOSTS.US
}

export function sellerCentralHostForMarketplace (marketplace) {
  var mp = normalizeMarketplaceCode(marketplace)
  if (mp && SELLER_CENTRAL_HOSTS[mp]) return SELLER_CENTRAL_HOSTS[mp]
  return SELLER_CENTRAL_HOSTS.US
}

export function extractAsinFromUrl (url) {
  if (!url || typeof url !== 'string') return null
  var dp = url.match(/\/dp\/([A-Z0-9]{10})/i)
  if (dp) return dp[1].toUpperCase()
  var gp = url.match(/\/gp\/product\/([A-Z0-9]{10})/i)
  if (gp) return gp[1].toUpperCase()
  return null
}

export function amazonListingUrl (asin, marketplace, fallbackUrl) {
  var code = asin ? String(asin).trim().toUpperCase() : ''
  if (!code) code = extractAsinFromUrl(fallbackUrl) || ''
  if (!code) return fallbackUrl || null
  var host = amazonHostForMarketplace(marketplace, fallbackUrl)
  return 'https://' + host + '/dp/' + code
}

/**
 * Seller Central inventory search for an ASIN on the correct regional host.
 * Example: IT → https://sellercentral.amazon.it/inventory?search=B0HCMJS6YN
 */
export function sellerCentralAsinUrl (asin, marketplace) {
  var code = asin ? String(asin).trim().toUpperCase() : ''
  if (!code) return null
  var mp = normalizeMarketplaceCode(marketplace)
  if (!mp || !SELLER_CENTRAL_HOSTS[mp]) return null
  var host = SELLER_CENTRAL_HOSTS[mp]
  return 'https://' + host + '/inventory?search=' + encodeURIComponent(code)
}

/** Matches alert-email wording: "IT Marketplace". */
export function marketplaceColumnLabel (marketplace) {
  var mp = normalizeMarketplaceCode(marketplace)
  if (!mp) return ''
  return mp + ' Marketplace'
}

export function marketplaceFlagClass (marketplace) {
  var mp = normalizeMarketplaceCode(marketplace).toLowerCase()
  if (!mp) return 'flag'
  if (mp === 'uk') return 'gb flag'
  return mp + ' flag'
}



// WEBPACK FOOTER //
// ./src/utils/amazonMarketplaceUrls.js